module.exports = __webpack_public_path__ + "static/media/gbr.526d1476.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gbr.png
// module id = 104
// module chunks = 0